import { UserRole } from '@whispers/sdk';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Navigation } from '../components/Navigation.js';
import { PreviewPlaceholder } from '../components/PreviewPlaceholder.js';
import { Spinner } from '../components/Spinner.js';
import { useAuth } from '../contexts/AuthContext.js';
import { useStoryblokPreview } from '../contexts/StoryblokPreviewContext.js';

export const AdminLayout = () => {
  const { user, isLoading } = useAuth();
  const { isPreviewMode, isLoading: previewIsLoading } = useStoryblokPreview();
  const location = useLocation();

  if (isLoading || previewIsLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <Spinner />
      </div>
    );
  }

  if (!user && !isPreviewMode) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  if (!isPreviewMode && user?.role !== UserRole.enum.ADMIN) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-dvh bg-background">
      <Navigation />
      <main className="mx-auto max-w-6xl px-4 py-8">
        {isPreviewMode ? <PreviewPlaceholder /> : <Outlet />}
      </main>
    </div>
  );
};
